var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26747 11.0148C3.13358 10.882 3.02731 10.724 2.95478 10.5499C2.88226 10.3758 2.84492 10.1891 2.84492 10.0006C2.84492 9.81198 2.88226 9.62527 2.95478 9.45119C3.02731 9.27712 3.13358 9.11912 3.26747 8.98633L9.82423 2.44385C9.95812 2.31105 10.0644 2.15306 10.1369 1.97898C10.2094 1.80491 10.2468 1.6182 10.2468 1.42962C10.2468 1.24104 10.2094 1.05433 10.1369 0.880257C10.0644 0.706183 9.95812 0.54819 9.82423 0.415394C9.55659 0.149336 9.19453 0 8.81715 0C8.43976 0 8.07771 0.149336 7.81006 0.415394L1.2533 6.97216C0.45077 7.77569 0 8.8649 0 10.0006C0 11.1362 0.45077 12.2254 1.2533 13.029L7.81006 19.5857C8.07613 19.8496 8.43525 19.9984 8.81 20C8.998 20.0011 9.18437 19.965 9.35841 19.8939C9.53245 19.8229 9.69075 19.7181 9.82423 19.5857C9.95812 19.4529 10.0644 19.2949 10.1369 19.1209C10.2094 18.9468 10.2468 18.7601 10.2468 18.5715C10.2468 18.3829 10.2094 18.1962 10.1369 18.0221C10.0644 17.848 9.95812 17.6901 9.82423 17.5573L3.26747 11.0148Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.6ff08a77120be6b8f6cbf494026d022b.svg";
export { ForwardRef as ReactComponent };